import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import useUserData from 'data-hooks/useUserData';
import { CREATE_KUSTOMER_TICKET } from 'mocks/mutations';
import ContactEnquiryFormUI from './ContactEnquiryFormUI';
import ContactEnquiryFormSuccessUI from './ContactEnquiryFormSuccessUI';
import withAdminPlaceholderHOC from '../../essentials/WithAdminPlaceholder';
import TextComponentNew from '../text-component';
import IconTextSet from '../icon-text-set';
const ContactEnquiryForm = () => {
  const $ = _c(10);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      onCompleted: data => {
        if (data?.createKustomerTicket?.success) {
          setIsSuccess(true);
        } else {
          setError(data?.createKustomerTicket?.errors?.[0]?.message || "Unable to submit the request. Please try again.");
        }
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [createKustomerTicketMutation, t1] = useMutation(CREATE_KUSTOMER_TICKET, t0);
  const {
    loading
  } = t1;
  const {
    isTradeUser
  } = useUserData();
  let t2;
  if ($[1] !== createKustomerTicketMutation || $[2] !== isTradeUser) {
    t2 = async t3 => {
      const {
        tag,
        name,
        email,
        phone,
        subject,
        question,
        message,
        subscribe,
        reCaptchaValue
      } = t3;
      setError(null);
      const tags = [tag];
      if (isTradeUser) {
        tags.push("trade_routing");
      }
      await createKustomerTicketMutation({
        variables: {
          input: {
            tags,
            contact_name: name,
            contact_email: email,
            contact_phone: phone,
            contact_message: message,
            chosen_subject: subject,
            chosen_question: question,
            contact_subscribe: !!subscribe,
            recaptcha_value: reCaptchaValue
          }
        }
      });
    };
    $[1] = createKustomerTicketMutation;
    $[2] = isTradeUser;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onSubmit = t2;
  let t3;
  if ($[4] !== error || $[5] !== isSuccess || $[6] !== isTradeUser || $[7] !== loading || $[8] !== onSubmit) {
    t3 = isSuccess ? <ContactEnquiryFormSuccessUI /> : <><TextComponentNew config={{
        cta: {
          linkTo: "",
          content: ""
        },
        text: {
          content: isTradeUser ? "Mon - Fri: 7:00 am - 4:00 pm PT<br />Sat - Sun: Closed" : "Mon - Fri: 6:00 am - 5:00 pm PT<br />Sat - Sun: 8:00 am - 4:00 pm PT"
        },
        header: {
          content: "Need help? Get in touch.",
          tagName: "h1"
        }
      }} /><ContactEnquiryFormUI loading={loading} error={error} isSuccess={isSuccess} onSubmit={onSubmit} /><IconTextSet config={{
        heading: {
          content: "",
          tagName: "p"
        },
        columnCount: {
          content: "2"
        },
        contentColumn1: {
          imageProps: {
            src: isTradeUser ? "https://joybird2.imgix.net/user-uploads-staging/Screen-Shot-2020-08-12-at-12.07.31-PM-1597259407348.png" : "https://joybird3.imgix.net/Text%20-%202.png"
          },
          heading: {
            content: isTradeUser ? "Call us" : "Text us",
            tagName: "h3"
          },
          subText: {
            content: isTradeUser ? "<a href=\"tel:+18552084414\" class=\"!text-gray md:hidden\">855-208-4414</a><a href=\"tel:+18552084414\" class=\"!text-gray [text-decoration:none] max-[767px]:hidden\">855-208-4414</a>" : "<a href=\"sms:+12136006313\" class=\"!text-gray md:hidden\">213-600-6313</a><a href=\"sms:+12136006313\" class=\"!text-gray [text-decoration:none] max-[767px]:hidden\">213-600-6313</a>"
          }
        },
        contentColumn2: {
          imageProps: {
            src: isTradeUser ? "https://joybird2.imgix.net/EmailThumbnail.png" : "https://joybird2.imgix.net/user-uploads-staging/Screen-Shot-2020-08-12-at-12.07.31-PM-1597259407348.png",
            alt: ""
          },
          heading: {
            content: isTradeUser ? "Email us" : "Call us",
            tagName: "h3"
          },
          subText: {
            content: isTradeUser ? "<a href=\"mailto:trade@joybird.com\" class=\"!text-brand cursor-pointer md:hidden\">trade@joybird.com</a> <a href=\"mailto:trade@joybird.com\" class=\"!text-brand cursor-pointer max-[767px]:hidden\">trade@joybird.com</a>" : "<a href=\"tel:+18882820842\" class=\"!text-gray  md:hidden\">888-282-0842</a><a href=\"tel:+18882820842\" class=\"!text-gray [text-decoration:none] max-[767px]:hidden\">888-282-0842</a>"
          }
        },
        contentColumn3: {
          imageProps: {
            src: isTradeUser ? "https://joybird3.imgix.net/Text%20-%202.png" : "https://joybird2.imgix.net/user-uploads-staging/Screen-Shot-2020-08-12-at-12.10.20-PM-1597259439357.png",
            alt: ""
          },
          heading: {
            content: isTradeUser ? "Text us" : "FAQ",
            tagName: "h3"
          },
          subText: {
            content: isTradeUser ? "<a href=\"sms:+12139082099\" class=\"!text-gray md:hidden\">213-908-2099</a><a href=\"sms:+12139082099\" class=\"!text-gray [text-decoration:none] max-[767px]:hidden\">213-908-2099</a>" : "<a href=\"https://help.joybird.com\" target=\"_blank\">Help Center</a>"
          }
        }
      }} /></>;
    $[4] = error;
    $[5] = isSuccess;
    $[6] = isTradeUser;
    $[7] = loading;
    $[8] = onSubmit;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default withAdminPlaceholderHOC({
  componentName: 'ContactEnquiryForm'
})(ContactEnquiryForm);